/**
 * Domains and the Rune Pool (CR 134, 163-167; research 01 §8; docs/design/03 §8.1).
 *
 * The table layer stores the pool so every tier shares one state shape; tier 1 never fills it (players
 * pay by exhausting and recycling runes by hand). The rules layer's payment planner reads and writes it.
 */

/** The six domains (CR 134.2). Domainless cards are "Colorless" in the catalogue. */
export const DOMAINS = ['Fury', 'Calm', 'Mind', 'Body', 'Chaos', 'Order'] as const;
export type Domain = (typeof DOMAINS)[number];

/**
 * One unit of resource in a player's Rune Pool (CR 166). Energy has no domain (CR 163.1); Power has a
 * domain, or `any` for universal Power (CR 163.2.b, 135.2.e.5.b).
 */
export type PoolUnit =
  | { kind: 'energy'; restriction: string | null }
  | { kind: 'power'; domain: Domain | 'any'; restriction: string | null };
// `restriction` names a spend restriction ("only to play spells", research 02 Q4), defined by the rules layer.
